<template>
	<div>
		<div class="sitecontent">
			<div class="contact_banner">
				<div class="container">
					<div class="row cont">
						<h1 class="wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
							专注提供云打印解决方案与服务</h1>
						<p class="wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
							为客户提供可靠、持续的服务，让每个创造价值</p>
					</div>
				</div>
			</div>
		</div>
		<div class="npagePage contact">
			<div class="intro_cont">
				<div class="container">
					<div class="clearfix row">
						<div class="intro_tab-content tab-content">
							<div class="tab-pane_na">
								<div class="clearfix row">
									<h3 class="header_title">
										<p class="title">联系我们</p>
									</h3>
								</div>
								<div class="row contact_cont wow fadeInUp animated"
									style="visibility: visible; animation-name: fadeInUp;">
									<ul>
										<li class="col-xs-4 bri">
											<p class="img">
												<img src="/static/img/contact_icon1.png" />
											</p>
											<p class="h5">公司地址</p>
											<p>广州市天河区珠村大粒沙路38号4栋</p>
										</li>
										<li class="col-xs-4 bri">
											<p class="img">
												<img src="/static/img/contact_icon2.png" />
											</p>
											<p class="h5">公司电话</p>
											<p>13600093009</p>
										</li>
										<li class="col-xs-4">
											<p class="img">
												<img src="/static/img/contact_icon3.png" />
											</p>
											<p class="h5">邮箱</p>
											<p>
												<a href="mailto:server@zonelink.cc">server@zonelink.cc</a>
											</p>
										</li>
									</ul>
								</div>
								<div class="row contact_cont2">
									<ul>
										<li class="col-xs-3 wow fadeInUp animated"
											style="visibility: visible; animation-name: fadeInUp;">
											<h4>销售经理</h4>
											<p>
												<span>联系人：</span>梁经理
											</p>
											<p>
												<span>电话：</span>15017026610
											</p>
											<p>
												<span>微信号：</span>wxid_q9y4xtv1a25d21
											</p>
											<p>
												<span>邮箱：</span>
												<a href="mailto:sell@zonelink.cc">sell@zonelink.cc</a>
											</p>
										</li>
										<li class="col-xs-3 wow fadeInUp animated"
											style="visibility: visible; animation-name: fadeInUp;">
											<h4>售后客服</h4>
											<p>
												<span>联系人：</span>胡先生
											</p>
											<p>
												<span>电话：</span>13696988194
											</p>
											<p>
												<span>微信号：</span>hutuyang_2005
											</p>
											<p>
												<span>邮箱：</span>
												<a href="mailto:service@zonelink.cc">service@zonelink.cc</a>
											</p>
										</li>
										<li class="col-xs-3 wow fadeInUp animated"
											style="visibility: visible; animation-name: fadeInUp;">
											<h4>市场合作</h4>
											<p>
												<span>联系人：</span>马先生
											</p>
											<p>
												<span>电话：</span>18688777685
											</p>
											<p>
												<span>微信号：</span>maliang_311
											</p>
											<p>
												<span>邮箱：</span>
												<a href="mailto:market@zonelink.cc">market@zonelink.cc</a>
											</p>
										</li>
										<li class="col-xs-3 wow fadeInUp animated"
											style="visibility: visible; animation-name: fadeInUp;">
											<h4>技术支持</h4>
											<p>
												<span>联系：</span>蔡先生
											</p>
											<p><span>电话：</span>18138794144</p>
											<p>
												<span>微信：</span>WDM-18138794144
											</p>
											<p>
												<span>邮箱：</span>
												<a href="mailto:tech@zonelink.cc">tech@zonelink.cc</a>
											</p>
										</li>
									</ul>
								</div>

								<div class="clearfix row">
									<h3 class="header_title">
										<p class="title">公司简介</p>
									</h3>
								</div>
								<div class="row about_cont wow fadeInUp animated"
									style="visibility: visible; animation-name: fadeInUp;">
									<div class="about_cont">
										<p>众联云是一家创新型技术性公司，为企业提供云打印解决方案相关产品的研发和服务，拥有强大的技术研发团队和全面的综合服务体系。</p>
										<p>众联云管理平台由广州众联云技术有限公司开发，本公司是一家专注物联网解决方案的高新科技公司，我们在万物互联的时代趋势推动下，紧跟潮流，运用最新科技成果，研发各类处于行业领先水平的智能终端，致力于满足客户的多样化需求，降低经营成本，提高生产效率。通过众联云数据处理中心的数据聚合能力，结合稳定高效的4G/5G通讯技术，实现24小时全天候不漏单智能打印，无需手机，无需电脑，无需人工参与。众联云打印机支持多店铺绑定，来单真人语音提醒，催单提醒，退款申请提醒，个性化定制小票等功能，感谢您的支持和使用。
										</p>
										<p>多年来，众联云致力于整合企业云打印服务，秉承“创新、求实、诚信、拼搏”的企业精神，为各行业商家提供全方位的打印研发、帮助餐饮商家自动接收，自动打印平台订单，提高了商家处理订单的效率，真正实现应用智能化，提升商家在网络经济市场的竞争力。以客户为中心，以技术为基础，以质量求生存，以诚信求发展，专业、专注为客户提供一个立体化的云打印解决方案。
										</p>
										<br />
										<br />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import $ from 'jquery'
export default {
	data() { return {} },
	mounted() {
		$(function ($) {

			'use strict';

			var $body_html = $('body, html'),
				$html = $('html'),
				$body = $('body'),
				$scroll_to_top = $('#scroll-to-top'),

				$preloader = $('#preloader'),
				$loader = $preloader.find('.loader');



			/*-----------------------------------------------------------------
			 * Is mobile
			 *-----------------------------------------------------------------*/

			var ua_test = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
				is_mobile = ua_test.test(navigator.userAgent);
			$html.addClass(is_mobile ? 'mobile' : 'no-mobile');


			// Init WOW
			// new WOW().init({ mobile: false });


			/*-----------------------------------------------------------------
			 * Finish loading
			 *-----------------------------------------------------------------*/

			$(window).load(function () {

				/* Remove preloader */

				$loader.delay(1500).fadeOut();
				$preloader.delay(500).fadeOut('slow');

				$body.addClass('loaded');

			});

		});

		/*导航 */
		$(document).ready(function () {
			$(window).scroll(function () {
				var top = $("body").offset().top;
				var scrollTop = $(window).scrollTop();
				if (scrollTop > top) { //滑动到该位置时执行代码
					$(".header").addClass("active");
				} else {
					$(".header").removeClass("active");
				}
			});
		});



		$(".imgli").click(function () {
			$(".imgli").removeClass("cur");
			$(this).addClass("cur");
			var str = $(this).attr("src");
			$("#J_imgBooth").attr("src", str)
		});
		$(function () {
			// $(".property-btn a").popover({
			// 	html: true
			// })
		});
		$(".nav li").hover(function () {
			$(this).children(".dropdown-menu").slideDown(100);
			$(this).children("a").addClass("cur")
		}, function () {
			$(".nav .dropdown-menu").hide();
			$(this).children("a").removeClass("cur")
		});


		$(function () {
			$("#mywxTab li a").hover(function (e) {
				$(this).tab('show');
			});
		});

	}
}
</script>


<style scoped>
.row {
	margin-left: 0px;
	margin-right: 0px;
}
</style>


// WEBPACK FOOTER //
// downloadContent.vue?38c7d5d5